import { AllowedHttpMethods, employeeReportApiConfig } from '../../apiList'
import {
  EmployeeReportApiProps,
  EmploymentStatus,
  Country,
  GetEmployeeResponse,
  ExportEmployeeReport,
} from '../../../../types/EmployeeDirectory/EmployeeReport/employeeReportTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'

const getEmployeeReport = async (
  props: EmployeeReportApiProps,
): Promise<GetEmployeeResponse> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: employeeReportApiConfig.getEmployeeReports,
    method: AllowedHttpMethods.get,
    params: {
      country: props.country ?? '',
      endIndex: props.endIndex ?? 20,
      searchStr: props.searchEmployee ?? '',
      selectionStatus: props.selectionStatus ?? EmploymentStatus.active,
      selectionType: props.selectedCategory ?? '',
      startIndex: props.startIndex ?? 0,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getCountries = async (): Promise<Country[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: employeeReportApiConfig.getCountries,
    method: AllowedHttpMethods.get,
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const exportEmployeeReportsData = async (
  props: ExportEmployeeReport,
): Promise<Blob | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: employeeReportApiConfig.exportEmployeeReportsData,
    method: AllowedHttpMethods.get,
    params: {
      selectionType: props.selectionType,
      country: props.country ?? '',
      selectionStatus: props.selectionStatus ?? EmploymentStatus.active,
      token: localStorage.getItem('token') ?? '',
      tenantKey: localStorage.getItem('token') ?? '',
    },
    responseType: 'blob',
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const employeeReportApi = {
  getEmployeeReport,
  exportEmployeeReportsData,
  getCountries,
}

export default employeeReportApi
